import createVueApp from '@phoenix/createVueApp';
import AdvancedIframe from '@maison/components/common/AdvancedIframe.vue';

Array.from(document.querySelectorAll('.phoenix-advanced-iframe')).forEach((el) => {
  const app = createVueApp();
  app.component('AdvancedIframe', AdvancedIframe);
  app.mount(el);
});
